import { defineStore } from "pinia";
import Services from '@/services/sutting/educationalInstitutionsServices'
import {  mapEducationalInstitution, mapList } from '@/helpers/mapFuncs'


export const useEducationalInstitutionsStore = defineStore("educationalInstitutions", {
persist: true,
state:()=>({
    educationalInstitution: {},
    educationalInstitutions: [],
}),
getters : {
    getEducationalInstitution() {
        return mapEducationalInstitution(this.educationalInstitution)
    },
    getEducationalInstitutions() {
        return this.educationalInstitutions.map(mapEducationalInstitution)
    },
    getEducationalInstitutionsList() {
        return this.educationalInstitutions.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setEducationalInstitution(educationalInstitution) {
        this.educationalInstitution = educationalInstitution
    },
    setEducationalInstitutions(educationalInstitutions) {
        this.educationalInstitutions = educationalInstitutions
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setEducationalInstitution(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setEducationalInstitutions(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.educationalInstitutions.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.educationalInstitutions[this.educationalInstitutions.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.educationalInstitutions = this.educationalInstitutions.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
